import React, { Component } from 'react';
import styled from 'styled-components';

const Background = styled.div`
  position: fixed;
  top: 0px;
  z-index: 8950;
  opacity: 0.5;
  height: 1072px;
  left: 0px;
  width: 100%;
  background-color: black;
`

const Modal = styled.div`
  max-width: 550px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -150px;
  margin-left: -250px;
  ${'' /* width: 200px; */}
  ${'' /* height: 200px; */}
  z-index: 8951;
  background-color: white;
  border-radius: 5px;
  padding: 25px;
`
const Cross = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  font-size: 24px;
  height: 20px;
  width: 20px;
  padding: 5px;
  padding-top: 0;
  padding-right: 25px;
  margin: 0;
  color: grey;
  &:hover {
    cursor: pointer;
    color: black;
  }
`

class ModalWrapper extends Component {
  // constructor() {
  //   super()
  //   // this.state = { escapePressed: false };
  // }
  // componentDidUpdate() {
  //   console.log('STATE:', this.state);
  // }
  keyListener = (e) => {
    // console.log('KEYDOWN', e);
    if (e.keyCode===27) {
      this.props.close();
      // this.setState({ escapePressed: true })
    }
  }
  componentDidMount() {
    document.addEventListener('keydown', this.keyListener, false);
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.keyListener, false);
  }
  render() {
    return this.props.open ? (
      <div>
        <Background onClick={() => {this.props.close();}} >
        </Background>
        <Modal>
          <Cross onClick={() => {this.props.close();}}>x</Cross>
          {this.props.children}
        </Modal>
      </div>
    ) : (
      <div></div>
    );
  }
}

export default ModalWrapper;



// WEBPACK FOOTER //
// ./src/_Modal.js